// src/pages/servicos/tecnicos/TecnicoResponsavelCad.js
import React, { useEffect, useState } from 'react';

import Input from '../../../components/input/Input';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import { useTecnicoResponsavel } from '../../../contexts/servicos/TecnicoResponsavelContext';
import { TecnicoResponsavel } from '../../../models/servicos/TecnicoResponsavel';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const TecnicoResponsavelCad = ({ show, onHide, initialTecnico, onSaveTecnico }) => {
  const [tecnico, setTecnico] = useState(new TecnicoResponsavel());
  const { adicionar, atualizar, excluir } = useTecnicoResponsavel();
  const { showMessage } = useMessage();
  const { showYesNo } = useYesNo();

  useEffect(() => {
    if (show) {
      setTecnico({ ...new TecnicoResponsavel(), ...(initialTecnico || {}) });
    }
  }, [show, initialTecnico]);

  const salvar = async () => {
    if (!tecnico.nome?.trim()) {
      showMessage('Informe o nome do técnico responsável!', 'warning');
      return;
    }
    const salvo = tecnico.id ? await atualizar(tecnico) : await adicionar(tecnico);
    if (salvo) onSaveTecnico?.(salvo);
  };

  const remover = async () => {
    if (!tecnico.id) return;
    if (!await showYesNo('Deseja excluir o técnico responsável selecionado?')) return;
    if (await excluir(tecnico.id)) onSaveTecnico?.({ excluido: true, id: tecnico.id });
  };

  if (!show) return null;

  return (
    <ModalContainer show={show} variant="cadastro" onHide={onHide}>
      <ModalHeader title={<>{tecnico.id ? 'Alterar técnico responsável' : 'Novo técnico responsável'}</>} onHide={onHide} />
      <ModalBody>
        <div className="d-flex gap-2 flex-wrap">
          <Input label="Código" value={tecnico.id || ''} disabled size={100} />
          <Input
            label="Nome"
            value={tecnico.nome || ''}
            onChange={evento => setTecnico({ ...tecnico, nome: evento.target.value })}
            size={420}
            autoFocus
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalActions >
          <ModalActionButton type="button" className="btn btn-primary" onClick={salvar} action="save">
            Salvar
          </ModalActionButton>
          <ModalActionButton
            type="button"
            className="btn btn-danger"
            disabled={!tecnico.id}
            onClick={remover}
           action="delete">
            Excluir
          </ModalActionButton>
        </ModalActions>
        <ModalActionButton type="button" className="btn btn-secondary" onClick={onHide} action="close">Fechar</ModalActionButton>
      </ModalFooter>
    </ModalContainer>
  );
};

export default TecnicoResponsavelCad;
